import { __rest } from "tslib";
import { refineModelForRequest } from '@/client/formatters/utils';
export const formatZone = (_a) => {
    var { copyable = true } = _a, data = __rest(_a, ["copyable"]);
    return (Object.assign(Object.assign({}, refineModelForRequest(data)), { copyable }));
};
export default formatZone;
